export const SUBSCRIBTION_SUCCESS = 'SUBSCRIBTION_SUCCESS'
export const FORM_NAME = 'emailInitialSignUpForm'
export const EMAIL_PROPERTY = 'email'
export const EMAIL_EMPTY_ERROR = 'Please enter your email address.'
